import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";

// Swiper CSS
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const AffiliateSlider = () => {
  const CountryFlagBanner = [
    { id: 1, banner: "/assets/Flag/flag-symbolism-Pakistan-design-Islamic.png", title: "Pakistan" },
    { id: 2, banner: "/assets/Flag/Flag-Cambodia.png", title: "Cambodia" },
    { id: 3, banner: "/assets/Flag/Flag_of_philippines.svg.jpg", title: "Philippines" },
    { id: 4, banner: "/assets/Flag/Flag_of_Brazil.svg.png", title: "Brazil" },
    { id: 5, banner: "/assets/Flag/Flag_of_India.svg.png", title: "India" },
    { id: 6, banner: "/assets/Flag/Flag_of_Bangladesh.svg.png", title: "Bangladesh" },
  ];

  return (
    <Swiper 
      modules={[Navigation, Pagination, Autoplay]}
      spaceBetween={10}
      slidesPerView={3}
      navigation={false}
      pagination={{ clickable: true }}
      autoplay={false}
      speed={1000}
      loop={true}
      style={{ padding: "0 10px 15px",marginTop:'25px' }} // bottom padding for dots
    >
      {CountryFlagBanner.map((item) => (
        <SwiperSlide key={item.id}>
          <div className="slider-items" style={{ textAlign: "center" }}>
            <figure
              style={{
                margin: 0,
                width: "100%",
                height: "80px",
                overflow: "hidden",
                borderRadius: "6px",
              }}
            >
              <img
                src={item.banner}
                alt={item.title}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </figure>
            <p
              style={{
                color: "#fff",
                textTransform: "uppercase",
                marginTop: "6px",
                fontSize: "12px",
                letterSpacing: "1px",
              }}
            >
              {item.title}
            </p>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default AffiliateSlider;